export default layout => ({
  info: {
    routeName: `fiscalizacao.docs.${layout}.info`,
    title: 'Informações',
  },
  valores: {
    routeName: `fiscalizacao.docs.${layout}.valores`,
    title: 'Valores',
  },
  grau_de_infracao: {
    routeName: `fiscalizacao.docs.${layout}.grau_de_infracao`,
    title: 'Grau',
  },
  irregularidades: {
    routeName: `fiscalizacao.docs.${layout}.irregularidades`,
    title: 'Irregularidades',
  },
  comentario: {
    routeName: `fiscalizacao.docs.${layout}.comentario`,
    title: 'Comentário',
  },
  textos: {
    routeName: `fiscalizacao.docs.${layout}.textos`,
    title: 'Textos',
  },
  confirmar: {
    routeName: `fiscalizacao.docs.${layout}.confirmar`,
    title: 'Confirmar',
  },
})
